import { Media, Story } from '../../../schema';
import { Fragment, useState } from 'react';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { Menu, Transition } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import { Button } from '../../../components/Button';

export interface StoryElementProps {
  story: Story;
  onEdit: () => void;
  deleteStory: (storyId: string) => void;
}

const mediaUrl = (tripId: string, media: Media) =>
  `https://media.${process.env.REACT_APP_HOST}/${tripId}/${media.id}-thumbnail.${media.ext}`;

export const StoryElement = (props: StoryElementProps) => {
  const [locale] = useState(navigator.language);

  const date = locale.startsWith('de')
    ? format(new Date(props.story.date), 'd. MMMM yyyy', {
      locale: de,
    })
    : format(new Date(props.story.date), 'MMMM d, yyyy', {
      locale: enUS,
    });

  return (
    <div className="relative">
      <Menu as="div" className="absolute top-2 right-2">
        <Menu.Button className="p-2 rounded-full hover:bg-muted">
          <EllipsisVerticalIcon className="w-6 h-6" />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-surface py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <Menu.Item>
              {({ active }) => (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={props.onEdit}
                  className={`w-full justify-start rounded-none px-4 text-main`}
                >
                  Edit Story
                </Button>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
      <div className="flex items-center justify-center mb-4 space-x-2 text-sm">
        <p>{date}</p>
        {props.story.place && <span>&bull;</span>}
        {props.story.place && <p>{props.story.place}</p>}
      </div>
      <h2 className="mt-1 text-4xl/9 text-center font-extrabold">{props.story.title}</h2>
      <p className="mt-4 text-lg text-center whitespace-pre-line">{props.story.description}</p>
      <div className="mt-6 flex flex-wrap gap-1 justify-center">
        {props.story.medias.map((media: Media) => (
          <img
            key={media.id}
            className="max-h-[200px] w-auto sm:max-w-none max-w-[40vw] rounded-xl object-cover"
            src={mediaUrl(props.story.tripId, media)}
          />
        ))}
      </div>
    </div>
  );
};
